function init() {
  const btns = $(this).find('.car-btn');
  const inputCarColor = $('.input-car-color');

  if (inputCarColor[0] && btns[0]) inputCarColor.val($(btns[0]).data('color'));

  btns.each(function () {
    $(this).on('click', function () {
      let type = $(this).parent().data('type');
      const carSlides = $(`.car-color-images[data-type="${type}"]`).find(
        'div[role="tabpanel"]'
      );
      const slides = carSlides[0] ? carSlides : $('.car-panel');
      btns.each(function () {
        $(this).attr('aria-selected', false);
      });
      $(this).attr('aria-selected', true);

      if (inputCarColor[0]) inputCarColor.val($(this).data('color'));

      slides.each((key, el) => {
        $(el).toggleClass(
          'delay-200 top-0 left-0 opacity-0 absolute',
          key !== $(this).data('index')
        );

        $(el).toggleClass('z-10', key !== $(this).data('index'));
      });
    });
  });
}

export default function () {
  $('section[data-block=hero]').each(init);
  if ($('.single-car')[0]) init.call($('.single-car'));
}
